/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Auth_LoginInputs */

const cs_audit_key_auth_login = /** @type {(inputs: Audit_Key_Auth_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatel přihlášen`)
};

const en_audit_key_auth_login = /** @type {(inputs: Audit_Key_Auth_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User logged in`)
};

/**
* | output |
* | --- |
* | "User logged in" |
*
* @param {Audit_Key_Auth_LoginInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_auth_login = /** @type {((inputs?: Audit_Key_Auth_LoginInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Auth_LoginInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_auth_login(inputs)
	return cs_audit_key_auth_login(inputs)
});